export default "__VITE_ASSET__dd250bf6__"